import {
    ANNOTATION_VIDEO_DISPLAY,
    // ANNOTATION_PARENT,
    VIDEO_PLAYING_MODE,
    // ANNOTATION_LOCATION,
    // VIDEO_SRC_TYPE
} from './GlobalConstants';
import * as THREE from "three";
// import * as THREE from 'three';

export const ANNOTATION_CONTACT_TEXT = '';
export const CONTACT_URL = 'WEBSITE';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const SPOTIFY = 'SPOTIFY';
export const TWITTER = 'TWITTER';
export const TIKTOK = 'TIKTOK';
export const IMDB = 'IMDB';
export const FACEBOOK = 'FACEBOOK';
export const ENQUIRE_EMAIL = 'ENQUIRE';
export const LINKED_IN = 'LINKEDIN';
export const HAS_MEDIA_CAROUSEL_LINK = 'MORE';
export const SEND_TO_EMAIL = 'SEND TO';
export const CANTALOUPE_IMAGE_SERVER = "https://iiif.v21artspace.com/iiif/2/silk-road%2Farmenia-2023%2F";
export const ANNOTATION_TEXT_ALIGNMENT = "justify";
export const ANNOTATION_TEXT_LINE_HEIGHT = "1.5";
export const GALLERY_LINK_LABEL = "TROUBLESHOOTING";

const INFO_TAG = '/assets/sprites/project_sprites/Info.svg';


const AnnotationsDB = [

    /* PERMANENT MATERIAL */
    /* AUDIO */
    {
        paintingId: 'NANINTA083',
        videoId: 'NANINTA083',
        standaloneVideoElementId: 'NANINTA083',
        videoURL: 'NANINTA083.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
    },
    /* AUDIO */
    /* VIDEO */
    {
        paintingId: 'NANINTV083',
        videoId: 'NANINTV083',
        standaloneVideoElementId: 'NANINTV083',
        videoURL: 'NANINTV083.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
    },
    /* VIDEO */

    /* AUDIO */
    {
        paintingId: 'ARM_CAD_A001_ARM',
        videoId: 'ARM_CAD_A001_ARM',
        standaloneVideoElementId: 'ARM_CAD_A001_ARM',
        videoURL: 'ARM_CAD_A001_ARM.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
    },
    {
        paintingId: 'ARM_INT_A046_ARM',
        videoId: 'ARM_INT_A046_ARM',
        standaloneVideoElementId: 'ARM_INT_A046_ARM',
        videoURL: 'ARM_INT_A046_ARM.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
    },
    {
        paintingId: 'ARM_POS_A027_ARM',
        videoId: 'ARM_POS_A027_ARM',
        standaloneVideoElementId: 'ARM_POS_A027_ARM',
        videoURL: 'ARM_POS_A027_ARM.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
    },
    {
        paintingId: 'ARM_REL_A002_ARM',
        videoId: 'ARM_REL_A002_ARM',
        standaloneVideoElementId: 'ARM_REL_A002_ARM',
        videoURL: 'ARM_REL_A002_ARM.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
    },
    {
        paintingId: 'ARM_REL_A003_ARM',
        videoId: 'ARM_REL_A003_ARM',
        standaloneVideoElementId: 'ARM_REL_A003_ARM',
        videoURL: 'ARM_REL_A003_ARM.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
    },
    {
        paintingId: 'ARM_REL_A005_ARM',
        videoId: 'ARM_REL_A005_ARM',
        standaloneVideoElementId: 'ARM_REL_A005_ARM',
        videoURL: 'ARM_REL_A005_ARM.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
    },
    {
        paintingId: 'ARM_REL_A007_ARM',
        videoId: 'ARM_REL_A007_ARM',
        standaloneVideoElementId: 'ARM_REL_A007_ARM',
        videoURL: 'ARM_REL_A007_ARM.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
    },
    {
        paintingId: 'ARM_SRD_A048_ARM',
        videoId: 'ARM_SRD_A048_ARM',
        standaloneVideoElementId: 'ARM_SRD_A048_ARM',
        videoURL: 'ARM_SRD_A048_ARM.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
    },
    /* AUDIO */

    /* TEXT ANNOTATIONS */
    /* Extras */
    {
        paintingId:"NANINTL124",
        videoId:"",
        videoURL:"",
        isMediaUsed: "N",
        headerText:"<h5>Sponsors</h5>",
        bodyText:`Blue Ninja: <u>https://blueninja.eu/</u><br>IIAS: <u>https://www.iias.asia/</u><br> New Silk Roads: <u>https://newsilkroads.info/</u>`,
        displayMesh:"N",
        useMeshButton:"N",
        urlLink2Label: "BlueNinja",
        urlLink2: "https://blueninja.eu/",
        urlLink3Label: "IIAS",
        urlLink3: "https://www.iias.asia/",
        urlLink1Label: "NSR",
        urlLink1: "https://newsilkroads.info/",
        spriteImageURL: INFO_TAG,
        annotation_location_vert_offset: 0.22,
        annotation_location_horiz_offset: -0.12,
        // annotation_location_z_offset: 1,
    },
    {
        paintingId:"VENSRM_T072",
        videoId:"",
        videoURL:"",
        isMediaUsed: "N",
        headerText:"<h6>Silk Road Virtual Museum 1200-1450</h6>",
        bodyText:"Welcome to the Silk Road Virtual Museum. The museum is designed to portray the art and culture of the societies that spanned the area between Asia and Europe.<br><br>The first period covered by the Museum is that between 1200 and 1450CE. This is seen by historians as the last period of overland trade and cultural exchange. It also witnessed the first Chinese diplomatic voyages that reached the Red Sea and the coast of West Africa. Gradually the period will be rolled backward to earlier epochs.<br><br>" + "The museum is formed by a network of different ‘city’ locations; each chosen to represent a particular culture. Cilicia 1226-1375 is the third of these museums." + "<br><br>Further information and eLibraries are available at:",
        displayMesh:"N",
        useMeshButton:"Y",
        urlLink1Label: "Silk Road VM-I",
        urlLink1: "https://silkroadvirtualmuseum.com/",
        urlLink2Label: "Silk Road VM-II",
        urlLink2: "https://silkroadvm.com/",
        spriteImageURL: INFO_TAG,
        annotation_location_vert_offset: -0.05,
        annotation_location_horiz_offset: -0.04,
        // annotation_location_z_offset: 1,
    },
    {
        paintingId:"NANDEPW127",
        videoId:"",
        videoURL:"",
        isMediaUsed: "N",
        headerText:`<h6>Silk Road Virtual Museum</h6>`,
        bodyText:`Thank-you for visiting the museum. If you would like to give us your feedback, to offer to help, to make a donation or to sign up for our newsletter, please click BELOW`,
        displayMesh:"Y",
        useMeshButton:"Y",
        urlLink1Label: "Silk Road Virtual Museum",
        urlLink1: "https://silkroadvirtualmuseum.com/landing/",
    },
    /* Extras */
    /* TEXT ANNOTATIONS */
    /* PERMANENT MATERIAL */

    /* Audio */

    // {
    //     paintingId: '',
    //     videoId: '',
    //     standaloneVideoElementId: '',
    //     videoURL: '.mp3',
    //     displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
    //     headerText: '',
    //     bodyText: null,
    //     displayMesh: 'Y',
    //     useVideoMeshButton: 'Y',
    //     displayHeight: 90,
    //     videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
    //     displayAudioSprite: 'N',
    //     videoLoop: false,
    //     videoAutoPlayDelay: 0,
    //     // videoButtonScale: {x:.05,y:.05,z:1},
    //     // video_button_z_offset: .01,
    //     // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
    //     // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
    //     // videoLoop: true,
    // },
    /* Audio */

    /* Videos */
    /* Videos */

    /* Text Annotations */
    {
        paintingId: "ARM_CAD_P001",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_CAD_P001.jpg/info.json`,
        headerText: `<h6>Carved Doors</h6>`,
        bodyText: `(Height) 185 cm x (Width) 115 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "ARM_REL_P003",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_REL_P003.jpg/info.json`,
        headerText: `<h6>Arm reliquary of<br>St Nicholas</h6>`,
        bodyText: `(Height) 47.5 cm x (Width) 9.5 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "ARM_REL_P004",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_REL_P004.jpg/info.json`,
        headerText: `<h6>Cross of John the Baptist</h6>`,
        bodyText: `(Height) 26.5 cm × (Width) 22 cm × (Depth) 2 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        // paintingId: "ARM_REL_P006",
        paintingId: "ARM_REL_P005",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ARM_REL_P005.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}ARM_REL_P006.jpg/info.json`],
        headerText: `<h6>Skevr Reliquary</h6>`,
        bodyText: `Dimensions open: (Height) 63.3 cm x (Width) 69.5 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "ARM_REL_P008",
        // paintingId: "ARM_REL_P007",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ARM_REL_P007.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}ARM_REL_P008.jpg/info.json`],
        headerText: `<h6>Reliquary of the<br>Holy Cross of the Vegetarians</h6>`,
        bodyText: `(Height) 44.2 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "ARM_STO_P017",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_STO_P017.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "ARM_STO_P018",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_STO_P018.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "ARM_STO_P019",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_STO_P019.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "ARM_STO_P020",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_STO_P020.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "ARM_STO_P021",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_STO_P021.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "ARM_STO_P022",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_STO_P022.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "ARM_STO_P023",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_STO_P023.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "ARM_STO_P024",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_STO_P024.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "ARM_STO_P025",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_STO_P025.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "ARM_STO_P026",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_STO_P026.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "ARM_STO_P063",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_STO_P063.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
// {
//         paintingId: "ARM_POS_P028",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P028.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
// {
//         paintingId: "ARM_POS_P029",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P029.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
// {
//         paintingId: "ARM_POS_P030",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P030.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
// {
//         paintingId: "ARM_POS_P031",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P031.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
// {
//         paintingId: "ARM_POS_P032",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P032.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
// {
//         paintingId: "ARM_POS_P033",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P033.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
// {
//         paintingId: "ARM_POS_P034",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P034.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
// {
//         paintingId: "ARM_POS_P035",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P035.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
// {
//         paintingId: "ARM_POS_P036",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P036.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
// {
//         paintingId: "ARM_POS_P037",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P037.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
// {
//         paintingId: "ARM_POS_P038",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P038.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
// {
//         paintingId: "ARM_POS_P039",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P039.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
// {
//         paintingId: "ARM_POS_P040",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P040.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
// {
//         paintingId: "ARM_POS_P041",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P041.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
// {
//         paintingId: "ARM_POS_P042",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P042.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
// {
//         paintingId: "ARM_POS_P043",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P043.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
// {
//         paintingId: "ARM_POS_P044",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P044.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
// {
//         paintingId: "ARM_POS_P045",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_POS_P045.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },
    /* INFORMATION MAP */
    {
        paintingId: "ARM_INT_P047",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_INT_P047.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    /* INFORMATION MAP */

    /* DEPARTURE LOUNGE */
    {
        paintingId: "ARM_DEP_P053",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_DEP_P053.jpg/info.json`,
        headerText: `<h6>Prince Vasak and His Family</h6>`,
        bodyText: `(Height) 26 cm x (Width) 20 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "ARM_DEP_P054",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_DEP_P054.jpg/info.json`,
        headerText: `<h6>King Levon and Queen Keran (1262)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "ARM_DEP_P055",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARM_DEP_P055.jpg/info.json`,
        headerText: `<h6>King Levon and his family (1272)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    /* DEPARTURE LOUNGE */
    /* Gospels Books */
    {
        paintingId: "ARM_GOS_GLA_P010",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://e.issuu.com/embed.html?d=gladzor_gospels&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h6>Gladozor Gospels</h6>`,
        bodyText: ``,
        displayMesh: "N",
        useMeshButton: "N",
    },
    {
        paintingId: "ARM_GOS_SEB_P011",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://e.issuu.com/embed.html?d=sebastia_gospels&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h6>Sebastia Gospel</h6>`,
        bodyText: ``,
        displayMesh: "N",
        useMeshButton: "N",
    },
    {
        paintingId: "ARM_GOS_TAR_P013",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://e.issuu.com/embed.html?d=targmantchants_gospels&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h6>Targmantchants Gospels</h6>`,
        bodyText: ``,
        displayMesh: "N",
        useMeshButton: "N",
    },
    {
        paintingId: "ARM_GOS_MAL_P012",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://e.issuu.com/embed.html?d=malatian_gospels&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h6>Malatian Gospels</h6>`,
        bodyText: ``,
        displayMesh: "N",
        useMeshButton: "N",
    },
    {
        paintingId: "ARM_GOS_MS5_P014",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://e.issuu.com/embed.html?d=ms_5786_gospels&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h6>MS 5786 Gospels</h6>`,
        bodyText: ``,
        displayMesh: "N",
        useMeshButton: "N",
    },
    {
        paintingId: "ARM_GOS_MS8_P015",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://e.issuu.com/embed.html?d=ms_8772_gospels&hideIssuuLogo=true&hideShareButton=true&u=mixedrealitiesltd',
        headerText: `<h6>MS 8772 Gospels</h6>`,
        bodyText: ``,
        displayMesh: "N",
        useMeshButton: "N",
    },

    /* THEATRE */
    {
        paintingId: "ARM_THE_P064",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/47BY125RCtc',
        headerText: `<h6>Medieval Armenian Music</h6>`,
        bodyText: `Click on the links below to listen to the originals`,
        displayMesh: "Y",
        useMeshButton: "Y",
        urlLink1Label: "Original #1",
        urlLink1: "https://youtu.be/ml9FcT5JO5c",
        urlLink2Label: "Original #2",
        urlLink2: "https://youtu.be/wuo0ZEoazbk",
    },
    /* THEATRE */

    /* Gospels Books */
// {
//         paintingId: "",
//         videoId: "",
//         videoURL: "",
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
//         headerText: `<h6></h6>`,
//         bodyText: ``,
//         displayMesh: "Y",
//         useMeshButton: "N",
//         // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
//     },

    // {
    //     paintingId: "VENREL_P017",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P017.jpg/info.json`,
    //     headerText: `<h6></h6>`,
    //     bodyText: `Height: 163 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    //     annotation_location_vert_offset: -0.16,
    //     annotation_location_horiz_offset: -0.32,
    // },

    /* INFORMATION AND EXCURSION DESK */
    {
        paintingId: "ARM_CID_T049",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/H5Zu08tKzs4',
        headerText: `<h6>Cilicia History</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "ARM_CID_T050",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/RFGOiBwJHY0',
        headerText: `<h6>Sis Castle<br>(drone view)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "ARM_CID_T051",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/WXr74EiZ4x8',
        headerText: `<h6>Sis Castle<br>(Armenian commentary)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "ARM_CID_T052",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/KjoFBWJpvWo',
        headerText: `<h6>History Museum of Armenia</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "ARM_EXC_T056",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/eHlMrfU3ib8',
        headerText: `<h6>Holy Mother of God Church<br>Yerevan (1264)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "ARM_EXC_T057",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/86m07jBEzJM',
        headerText: `<h6>Monastery of the Spear’<br>Geghard (1215)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "ARM_EXC_T058",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/KPf7kJDomoA',
        headerText: `<h6>Noravank Monastery<br>(13th century)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "ARM_EXC_T059",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/4MHE8qMRTIc',
        headerText: `<h6>Monastery of the Soaring Eagle<br>Dilijan National Park<br>(13th century)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "ARM_EXC_T060",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/Ff4x6mAL-yg',
        headerText: `<h6>Saghmosavank & Hovhannavank Monasteries<br>(1221)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "ARM_EXC_T061",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/a8Yg797_U8s',
        headerText: `<h6>Pghindzavank (‘Coppermine Monastery’) Akhtala<br>Built 10th century<br>Painted Frescos 1205-1216</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    /* INFORMATION AND EXCURSION DESK */
    /* Text Annotations */


];

export {AnnotationsDB};
